import type { ReactNode } from 'react';
import { ApiRequestError } from '../../api/http';

const tones = {
  info: 'border-info/40 bg-info/5 text-text',
  error: 'border-danger/50 bg-danger/10 text-danger',
  success: 'border-success/40 bg-success/10 text-text',
  warning: 'border-accent/50 bg-accent/10 text-text',
};

export function Notice({
  tone = 'info',
  children,
}: {
  tone?: keyof typeof tones;
  children: ReactNode;
}) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={`border-l-2 px-3 py-2 text-sm ${tones[tone]}`}
    >
      {children}
    </div>
  );
}

export function ErrorNotice({ error }: { error: unknown }) {
  const message =
    error instanceof ApiRequestError ? error.message : 'Something went wrong. Please try again.';
  return <Notice tone="error">{message}</Notice>;
}
